/**
 * Get the date display format string based on locale.
 * This is the application's responsibility, not the design system's.
 */
export function getDateFormatForLocale(locale) {
    if (locale.startsWith("fr"))
        return "dd/mm/yyyy";
    if (locale.startsWith("nl"))
        return "dd-mm-yyyy";
    return "yyyy-mm-dd"; // English, default
}
/**
 * Convert a date from display format to ISO 8601 (yyyy-mm-dd).
 * Uses the format string to resolve ambiguity (e.g. mm/dd/yyyy vs dd/mm/yyyy).
 * Returns the original string unchanged if parsing fails.
 */
export function displayDateToIso(displayDate, format) {
    if (!displayDate)
        return "";
    const parts = displayDate.split(/[/\-.]/).map((s) => s.trim());
    const formatParts = format
        .toLowerCase()
        .split(/[/\-.]/)
        .map((s) => s.trim());
    if (parts.length !== 3 || formatParts.length !== 3)
        return displayDate;
    if (parts.some((p) => !/^\d+$/.test(p)))
        return displayDate;
    const map = {};
    for (let i = 0; i < 3; i++) {
        const key = formatParts[i]; // "dd", "mm", "yyyy"
        map[key] = parts[i];
    }
    const year = map["yyyy"];
    const month = map["mm"];
    const day = map["dd"];
    if (!year || !month || !day)
        return displayDate;
    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
}
